import { AxiosError } from "axios";
import { useMutation } from "react-query";
import axiosClient from "../utils/axiosClient";

export const useDocumentTranslateMutation = () => {
  return useMutation<
    { jobId: number },
    AxiosError<any>,
    {
      file?: File;
      fromLang?: string;
      toLang: string;
    }
  >(
    ({ file, fromLang, toLang }) => {
      const body = new FormData();

      if(file){
        body.append("file", file);
      }
      
      body.append("toLang",toLang)

      if(fromLang){
        body.append("fromLang", fromLang);
      }

      return axiosClient
        .post(`/translation/document/action`, body, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 60 * 1000, // 1min
        })
        .then(({ data }) => data);
    },
    {
      retry: false,
    }
  );
};
